module.exports = __webpack_public_path__ + "img/14.fba85c9e.jpg";